import { EMPLOYEE_PAGE_QUERY } from '@/constants/urlQuery';
import { mergeSearchParams, parseSearchParams } from '@/utils/urlSearch';

/**
 * @param {string} search - `location.search`
 * @returns {{ company: string | null, team: string | null }}
 */
export function getEmployeePageFiltersFromSearch(search) {
  const q = parseSearchParams(search);
  const str = (key) =>
    typeof q[key] === 'string' ? q[key].trim() || null : null;

  return {
    company: str(EMPLOYEE_PAGE_QUERY.company),
    team: str(EMPLOYEE_PAGE_QUERY.team),
  };
}

/**
 * @param {{ companyId?: string, teamId?: string }} filters - empty string removes key
 * @returns {Record<string, string>}
 */
export function buildEmployeePageFilterUpdates({ companyId, teamId }) {
  return {
    [EMPLOYEE_PAGE_QUERY.company]: companyId ?? '',
    [EMPLOYEE_PAGE_QUERY.team]: teamId ?? '',
  };
}

/**
 * Merges company/team into the current query (keeps flow params).
 *
 * @param {string} currentSearch - `location.search`
 * @param {{ companyId?: string, teamId?: string }} filters
 * @returns {string}
 */
export function mergeEmployeePageFiltersIntoSearch(currentSearch, filters) {
  return mergeSearchParams(
    currentSearch,
    buildEmployeePageFilterUpdates({
      companyId: filters.companyId ?? '',
      teamId: filters.teamId ?? '',
    })
  );
}
